<div class="project-logbook-user-on">
    <!-- EVENT OWNER AND OBJECT -->
    <div class="event-user">
      <core-helper-box-header-user-date
        [user]="event.user"
        [preText]="'By'"
      ></core-helper-box-header-user-date>
    </div>
    <div class="event-object">
        <span class="project-pre">On</span>
        <ng-container [ngSwitch]="getReference()">
          <span class="event-request" *ngSwitchCase="EVENT_TRACK_REFERENCE.REQUEST">
            <em><strong>Project</strong> (#{{properties.request.id}})</em>
          </span>
          <span class="event-version" *ngSwitchCase="EVENT_TRACK_REFERENCE.VERSION">
              <em><strong>Version v{{properties.version.version}}</strong> (#{{properties.version.id}})</em>
          </span>
          <ng-container *ngSwitchCase="EVENT_TRACK_REFERENCE.MULTIPLE">
            <span class="event-version" *ngIf="properties.hasOwnProperty('version') else requestevent">
                <em><strong>Version v{{properties.version.version}}</strong> (#{{properties.version.id}})</em>

            </span>
            <ng-template #requestevent>
              <span class="event-request">
                <em><strong>Project</strong> (#{{properties.request.id}})</em>
              </span>
            </ng-template>
          </ng-container>
        </ng-container>
        
    </div>
</div>
